import React, { useState, useContext } from 'react';
import api from '../services/axios';
import { Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import alertService from '../services/alerts';
import '../styles/LoginPage.css';
import logo from '../assets/elon_logo.png';

function LoginPage() {
  const [correo, setCorreo] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    setIsLoading(true);

    try {
      const response = await api.post('/auth/login', {
        correo,
        contraseña: password
      });

      const { token, usuario } = response.data;
      if (token) {
        login(token, usuario);
        window.location.href = '/dashboard';
      } else {
        setErrorMessage('No se recibió un token de autenticación');
      }
    } catch (error) {
      let errorMsg = 'Correo o contraseña incorrecta';
      
      if (error.response?.status === 429) {
        errorMsg = error.response.data?.message || 
          'Has superado el límite de intentos. Intenta de nuevo más tarde.';
      }
      
      await alertService.error('Error de Autenticación', errorMsg);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-bg">
      <div className="login-card">
        <img 
          src={logo} 
          alt="Elon School Logo" 
          className="login-logo"
          loading="lazy"
        />

        <h1 className="login-title">Bienvenido</h1>
        {errorMessage && (
          <div className="error-message" role="alert">
            {errorMessage}
          </div>
        )}

        <form onSubmit={handleSubmit} noValidate>
          <div className="form-group">
            <label htmlFor="email">Correo Electrónico</label>
            <input
              id="email"
              type="email"
              value={correo}
              onChange={(e) => setCorreo(e.target.value)}
              placeholder="ejemplo@correo.com"
              required
              autoComplete="email"
              aria-describedby={errorMessage ? "error-message" : undefined}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Contraseña</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              autoComplete="current-password"
              aria-describedby={errorMessage ? "error-message" : undefined}
            />

            <div className="forgot-password-link">
              <Link to="/forgot-password">¿Olvidaste tu contraseña?</Link>
            </div>
          </div>

          <button 
            type="submit" 
            className="btn-login"
            disabled={isLoading}
          >
            {isLoading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default LoginPage;